import * as BrokerService from '../services/broker-service';

export function resetState(state) {
  return function (dispatch) {
    dispatch(reset(state));
  };
}

export function fetchBrokers() {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await BrokerService.list();
      dispatch(success('FETCH_BROKERS', response.data));
    } catch(err) {
      dispatch(error('BROKER_ERROR', err));
    }
  };
}

export function save(broker) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await BrokerService.save(broker);
      return dispatch(success('ADD_BROKER', response.data));
    } catch (err) {
      return dispatch(error('BROKER_ERROR', err));
    }
  };
}

export function update(broker) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await BrokerService.update(broker);
      return dispatch(success('UPDATE_BROKER', response.data));
    } catch (err) {
      return dispatch(error('BROKER_ERROR', err));
    }
  };
}

export function changeStatus(id) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await BrokerService.changeStatus(id);
      return dispatch(success('UPDATE_BROKER', response.data));
    } catch (err) {
      return dispatch(error('BROKER_ERROR', err));
    }
  };
}

/* Search Brokers */
export function search(searchParameters) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await BrokerService.search(searchParameters);
      dispatch(success('SEARCH_BROKERS', response.data));
    } catch(err) {
      dispatch(error('BROKER_ERROR', err));
    }
  };
}

function reset(type) {
  return {
    type: type,
  };
}

function process() {
  return {
    type: 'PROCESSING_BROKER',
  };
}

function success(type, data) {
  return {
    type: type,
    payload: data,
  };
}

function error(type, err) {
  let message;
  if (err.response) {
    // Request made and server responded
    const { data } = err.response;
    message = data && data.message;
  } else if (err.request) {
    // The request was made but no response was received
    message = err.request;
  } else {
    // Something happened in setting up the request that triggered an Error
    message = err.message;
  }
  return {
    type: type,
    payload: message,
  };
}